import { render, staticRenderFns } from "./OrdersLegend.vue?vue&type=template&id=0f6645e6&"
import script from "./OrdersLegend.vue?vue&type=script&lang=js&"
export * from "./OrdersLegend.vue?vue&type=script&lang=js&"
import style0 from "./OrdersLegend.vue?vue&type=style&index=0&id=0f6645e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports